import { render, staticRenderFns } from "./OrderActionRefundNotify.vue?vue&type=template&id=460b41ad&"
import script from "./OrderActionRefundNotify.vue?vue&type=script&lang=ts&"
export * from "./OrderActionRefundNotify.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports